<template>
  <svg viewBox="0 0 60 60" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.4958 30.5V56H33.9916V30.5H41.7115L42.9235 22H33.9916V18.3677C33.9916 15.1093 35.0564 13.5 38.1036 13.5H43V5.37117L42.9483 5.36418C42.0672 5.24511 40.2536 5 36.883 5C29.7041 5 25.4958 8.79383 25.4958 17.4355V22H17V30.5H25.4958Z"/>
  </svg>
</template>
